/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MedPillsBadIcon16Light } from './MedPillsBadIcon16Light';
import { MedPillsBadIcon16Regular } from './MedPillsBadIcon16Regular';
import { MedPillsBadIcon16Solid } from './MedPillsBadIcon16Solid';
import { MedPillsBadIcon20Light } from './MedPillsBadIcon20Light';
import { MedPillsBadIcon20Regular } from './MedPillsBadIcon20Regular';
import { MedPillsBadIcon20Solid } from './MedPillsBadIcon20Solid';
import { MedPillsBadIcon24Regular } from './MedPillsBadIcon24Regular';
import { MedPillsBadIcon24Solid } from './MedPillsBadIcon24Solid';
import { MedPillsBadIcon32Regular } from './MedPillsBadIcon32Regular';
import { MedPillsBadIcon64Regular } from './MedPillsBadIcon64Regular';
var sizes = {
    16: {
        light: MedPillsBadIcon16Light,
        regular: MedPillsBadIcon16Regular,
        solid: MedPillsBadIcon16Solid,
    },
    20: {
        light: MedPillsBadIcon20Light,
        regular: MedPillsBadIcon20Regular,
        solid: MedPillsBadIcon20Solid,
    },
    24: {
        regular: MedPillsBadIcon24Regular,
        solid: MedPillsBadIcon24Solid,
    },
    32: {
        regular: MedPillsBadIcon32Regular,
    },
    64: {
        regular: MedPillsBadIcon64Regular,
    },
};
export var MedPillsBadIcon = forwardRef('MedPillsBadIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
